import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useState
} from 'react';
import {ResponseVehicle} from '../../../types/api';

interface VisualContextInterface {
  vehicle: ResponseVehicle | null;
  set: Dispatch<SetStateAction<ResponseVehicle | null>>;
}

export const VisualContext = createContext<VisualContextInterface | null>(null);

const VisualContextProvider = ({children}: PropsWithChildren) => {
  const [vehicle, setVehicle] = useState<ResponseVehicle | null>(null);
  
  return (
    <VisualContext.Provider value={{vehicle, set: setVehicle}}>
      {children}
    </VisualContext.Provider>
  );
};

export default VisualContextProvider;
